/**
 * An array of regular expression special characters.
 *
 * Note:
 * - The order matters for the first group.
 * - The order does not matter for the subsequent characters.
 */
const REGEX_SPECIALS = [
  // Order matters for these characters
  '-',
  '[',
  ']',
  // Order doesn't matter for these characters
  '/',
  '{',
  '}',
  '(',
  ')',
  '*',
  '+',
  '?',
  '.',
  '\\',
  '^',
  '$',
  '|',
];

/**
 * Escapes special characters in a string for use in a regular expression.
 *
 * @param {string} str - The input string to escape.
 * @param {string[]} [exclude] - An optional array of characters that should not be escaped.
 * @returns {string} The escaped string where all special characters (except those excluded) are prefixed with a backslash.
 */
export function escapeRegExp(str: string, exclude?: string[]): string {
  const specials = exclude?.length ? REGEX_SPECIALS.filter((special) => !exclude.includes(special)) : REGEX_SPECIALS;

  const regex = new RegExp('[' + specials.join('\\') + ']', 'g');
  return str.replace(regex, '\\$&');
}
